import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { ModelPeopleForm } from "models/people/PeopleForm";
import { useResetPeople } from "models/people/apiPeople";
import {
  useNiceModalLocker,
  NiceModalComponent,
} from "components/context/NiceModalProvider";

export default NiceModal.create(({ id, formType }) => {
  const modal = useModal();
  const { setLocked, closeFormIfNotLocked } = useNiceModalLocker(modal);
  const resetPeople = useResetPeople();

  return (
    <NiceModalComponent open={modal.visible} onClose={closeFormIfNotLocked}>
      <ModelPeopleForm
        setIsDirty={setLocked}
        formType={formType}
        objectId={id}
        onUpdated={() => resetPeople(id)}
        onCancel={modal.hide}
      />
    </NiceModalComponent>
  );
});
